import { UsePricingModel } from '@client/new/pages/collection/pricing/pricing.model';
import { Typography } from '@design-system/components/typography/typography';
import { Link } from 'react-router';
import { clsx } from 'clsx';
import { sprinkles } from '@design-system/sprinkles.css';

const CardItem = ({
  children,
  link,
  linkLabel,
  disabled = false,
}: {
  children: React.ReactNode;
  linkLabel: string;
  disabled?: boolean;
  link: string;
}) => (
  <div className="flex flex-col w-full flex-1 justify-center">
    <div className="flex justify-between w-full items-center">
      {children}
      <Link to={link} className={disabled ? 'pointer-events-none' : ''}>
        <Typography
          className={clsx(
            disabled
              ? sprinkles({ color: 'B-100/50' })
              : sprinkles({ color: 'P-80' }),
          )}
        >
          {linkLabel}
        </Typography>
      </Link>
    </div>
  </div>
);

export const DiscountsCard = (p: UsePricingModel) => (
  <div className="flex flex-col p-6 bg-white rounded-[20px] grow gap-4">
    <div className="flex flex-col flex-1 divide-y *:py-3 xl:*:py-0 first:*:pt-0 last:*:pb-0">
      <CardItem
        link={p.viewPromoPageLink}
        linkLabel="Show all"
        disabled={p.couponsCount === 0}
      >
        <Typography>
          Discounts created:{' '}
          <strong className="pl-2">
            {p.couponsCount === 0 ? 'No discounts' : p.couponsCount}
          </strong>
        </Typography>
      </CardItem>
      <CardItem link={p.createPromoPageLink} linkLabel="Create">
        <Typography>Set up a discount</Typography>
      </CardItem>
    </div>
  </div>
);
